import LancarNotasPage from "@/Pages/Notas/LancarNotasPage.vue";
import CircuitoNotasPage from "@/Pages/Notas/CircuitoNotasPage.vue";
import CircuitoNotasInfantilPage from "@/Pages/Notas/CircuitoNotasInfantilPage.vue";

export default [
  {
    path: "/gestoes-de-aulas/:gestaoDeAulasId/notas/lancar",
    name: "notas.lancarNotas",
    component: LancarNotasPage,
  },
  {
    path: "/gestoes-de-aulas/:gestaoDeAulasId/notas/circuito-notas/:disciplinaId",
    name: "notas.circuitoNotas",
    component: CircuitoNotasPage,
  },
  {
    path: "/gestoes-de-aulas/:turmaId/notas/circuito-notas",
    name: "notas.circuitoNotasInfantil",
    component: CircuitoNotasInfantilPage,
  },
];
